<script setup lang="ts">
import { usePublicNavItems } from '@/composables/usePublicNavItems';

const navItems = usePublicNavItems({ videos: true });
</script>

<template>
  <nav class="hidden md:flex items-center gap-6">
     <RouterLink
       v-for="item in navItems"
       :key="item.to"
       :to="item.to"
       class="text-cream-100/80 hover:text-gold-400 transition-colors font-medium font-sans"
       active-class="text-gold-400"
     >
       {{ item.label }}
     </RouterLink>
  </nav>
</template>
